import iconMapping from '../../../animod-backoffice/app/mixins/marketingIconMapping';

export default {
    methods: {
        /**
         * @function
         * @param {string} icon
         * @returns {null|Object}
         */
        findIcon(icon) {
            if (icon) {
                return iconMapping.find(i => i.value === icon);
            }
            return null;
        },

        /**
         * @function
         * @param {string} icon
         * @returns {null|string} - webpack resolved src
         */
        getIconSrc(icon) {
            const foundIcon = this.findIcon(icon);
            if (foundIcon && foundIcon.imgSrc) {
                const iconSrc = foundIcon.imgSrc.split('/').pop();
                // requiring exactly icons folder to reduce the dynamic import bundle size, otherwise entire backoffice assets folder would be bundled
                return require('../../../animod-backoffice/public/assets/images/icons/' + iconSrc);
            }
            return null;
        },

        /**
         * @function
         * @param {string} icon
         * @returns {null|string}
         */
        getIconAlt(icon) {
            const foundIcon = this.findIcon(icon);
            if (foundIcon) {
                return foundIcon.text;
            }
            return null;
        }
    }
};
